/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const is = require("is_js");

export const CurrencyConversion = (exchangeRate: any, amount: any) => {
  let res: any = "0.00";
  let rate = Number(exchangeRate);
  if (!rate || isNaN(rate) || rate <= 0) {
    if (typeof window !== "undefined") {
      try {
        const { StorageModule } = require("@vlinder-web/storage-module-react");
        const storageSrv = StorageModule.getInstance();
        const sessionExchange =
          storageSrv?.get("currencyExchangeSession", "session") ??
          storageSrv?.get("currencyExchangeLocal", "local");
        rate = Number(sessionExchange?.conversion_rate) || 1;
      } catch (e) {
        rate = 1;
      }
    } else {
      rate = 1;
    }
  }
  if (
    amount !== undefined &&
    amount !== null &&
    amount !== "" &&
    !isNaN(Number(amount))
  ) {
    res = (Number(amount) / rate).toFixed(2).toString();
  }
  return res;
};

export const formatDualCurrency = (amountInTTD: any, exchangeRate?: any) => {
  const num = parseFloat(amountInTTD) || 0;
  let rate = Number(exchangeRate);
  if (!rate || isNaN(rate) || rate <= 0) {
    if (typeof window !== "undefined") {
      try {
        const { StorageModule } = require("@vlinder-web/storage-module-react");
        const storageSrv = StorageModule.getInstance();
        const sessionExchange =
          storageSrv?.get("currencyExchangeSession", "session") ??
          storageSrv?.get("currencyExchangeLocal", "local");
        rate = Number(sessionExchange?.conversion_rate) || 1;
      } catch (e) {
        rate = 1;
      }
    } else {
      rate = 1;
    }
  }
  const usd = (num / rate).toFixed(2);
  const ttd = num.toFixed(2);
  return `US$ ${usd} / TT$ ${ttd}`;
};
